import React              from 'react';
import PropTypes          from 'prop-types';
import Label              from 'pu-react/components/base/Label';
import RadioComponent     from 'pu-react/components/base/RadioComponent';

const ArraySide = props => (
  <RadioComponent
    name={props.name}
    label={props.label}
    value={props.value}
    checked={props.parameters[props.name] === props.value}
    onChange={() => props.onChangeParameter(props.name, props.value)}
    inputId={props.inputId}
    groupName={props.groupName} />
);

ArraySide.defaultProps = {
  name     : 'rails_sides',
  // groupName: 'customer',
  groupName: 'parameters',
};

ArraySide.propTypes = {
  name             : PropTypes.string,
  groupName        : PropTypes.string,
  label            : PropTypes.string.isRequired,
  value            : PropTypes.string.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  inputId          : PropTypes.string.isRequired,
  parameters       : PropTypes.object.isRequired,
};

const ArrayRailsSides = props => (
  <div className="form-group radio-group">
    <Label label="Add rails to" />
    <ArraySide
      label="the two long sides"
      value="two_long_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-long"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="the two short sides"
      value="two_short_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-short"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="all four sides"
      value="all_four_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-all"
      groupName={props.groupName}
      parameters={props.parameters} />
    <ArraySide
      label="no rails"
      value="no_sides"
      onChangeParameter={props.onChangeParameter}
      inputId="array-side-no"
      groupName={props.groupName}
      parameters={props.parameters} />
    <div className="error-place" />
  </div>
);

ArrayRailsSides.propTypes = {
  groupName: PropTypes.string,
  onChangeParameter: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
};

export default ArrayRailsSides;
